<aside class="download-popup" *ngIf="visible" role="complementary" aria-label="Get the Vector Marine app">
  <button type="button" class="download-popup__close" (click)="dismiss()" aria-label="Close">
    <svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    </svg>
  </button>

  <img class="download-popup__logo" src="/assets/login/vector_marine.png" alt="" />
  <div class="download-popup__body">
    <strong>Get the Vector Marine app</strong>
    <span>Trips, waypoints and chat on your phone.</span>
    <div class="download-popup__links">
      <a [href]="iosUrl" target="_blank" rel="noopener noreferrer">iOS</a>
      <a [href]="androidUrl" target="_blank" rel="noopener noreferrer">Android</a>
    </div>
  </div>
</aside>
